import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CUPO } from '../../../../config/forms'
import { EMPTY_CUPO } from '../../actions/constants'
import DialogView from '../../../Dialogos/DialogView'
import { Dialog } from '@material-ui/core'
import { NewAsignacionDialogView } from '../../components/asignacionCupos/NewAsignacionDialogView'
import * as actions from '../../actions'
import DialogoCorreoUpdate from '../../components/asignacionCupos/DialogoCorreoUpdate'
import DialogoContacto from '../../components/asignacionCupos/DialogoContacto'

class NewAsignacionDialog extends Component {
  constructor (props) {
    super(props)
    // this.actualizarFechas = this.actualizarFechas.bind(this)
    // this.handleChangeExportador = this.handleChangeExportador.bind(this)
    this.state = {
      openCorreoUpdate: false,
      isValid: false
    }
  }

  render () {
    const {
      confirmCallback,
      cancelCallback,
      change,
      actualizarDatosCuposParaAsignarMuiTable,
      submitAsignacionDeCuposCache,
      actualizarExportador,
      exportadorSeleccionado,
      correosSeleccionados,
      openAddCorreo,
      ocultarDialogCorreo,
      onSubmitNewContacto,
      updateListaContactos,
      updateNotificarPorCorreo,
      updateEnviarATodos
    } = this.props
    const {
      openCorreoUpdate
    } = this.state

    const handleOpenCorreoUpdate = () => {
      this.setState({ openCorreoUpdate: !this.state.openCorreoUpdate })
    }

    const handleOpenAdd = () => {
      ocultarDialogCorreo()
    }

    return (
      <>
        <Dialog
          open={openCorreoUpdate}
          onClose={handleOpenCorreoUpdate}
          fullWidth
          maxWidth='md'>
          <DialogoCorreoUpdate handleClose={handleOpenCorreoUpdate} />
        </Dialog>
        <Dialog
          open={openAddCorreo}
          onClose={handleOpenAdd}
          fullWidth
          maxWidth='sm'>
          <DialogoContacto
            handleClose={handleOpenAdd}
            onSubmitContacto={onSubmitNewContacto} />
        </Dialog>
        <DialogView
          confirmCallback={confirmCallback}
          cancelCallback={cancelCallback}
          title='Asignación de Cupos'
          content={
            <NewAsignacionDialogView
              change={change}
              actualizarMuiTable={actualizarDatosCuposParaAsignarMuiTable}
              actualizarExportador={actualizarExportador}
              handleCorreoUpdate={handleOpenCorreoUpdate}
              exportadorSeleccionado={exportadorSeleccionado}
              correosSeleccionados={correosSeleccionados}
              submitCache={submitAsignacionDeCuposCache}
              updateListaContactos={updateListaContactos}
              updateNotificarPorCorreo={updateNotificarPorCorreo}
              updateEnviarATodos={updateEnviarATodos}
            />
          }
        />
      </>
    )
  }
}
const mapStateToProps = (state) => ({
  exportadorSeleccionado: state.cupos.exportador,
  correosSeleccionados: state.cupos.correosSeleccionados,
  openAddCorreo: state.cupos.openAddCorreo,
  openEditCorreo: state.cupos.openEditCorreo
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(reduxForm({
  form: FORM_CUPO,
  initialValues: EMPTY_CUPO,
  enableReinitialize: false
})(NewAsignacionDialog))
